import React, { useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'https://rj2psn7fng.execute-api.us-east-1.amazonaws.com/v1';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) throw data;
      setSuccess(true);
    } catch (err) {
      setError(err.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h2>Invalid Link</h2>
          <p className="auth-subtitle">This reset link is invalid or has expired.</p>
          <Link to="/forgot-password" className="btn-primary" style={{display:'inline-block', marginTop:'1rem'}}>Request a new link</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Set New Password</h2>
        {success ? (
          <div>
            <p className="auth-subtitle" style={{color:'var(--accent-green)'}}>✓ Password reset successfully!</p>
            <p className="auth-link"><Link to="/vendor/login">Vendor login</Link> • <Link to="/customer/login">Customer login</Link></p>
          </div>
        ) : (
          <>
            <p className="auth-subtitle">Enter your new password below.</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <input type="password" placeholder="New password (8+ characters)" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
              <input type="password" placeholder="Confirm new password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Resetting...' : 'Reset Password'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
